import { Typography } from "@mui/material";

export const H2Component = ({ text }: { text: string }) => {
  return (
    <Typography variant="h4" component="h3" sx={{ color: "#024760" }}>
      {text}
    </Typography>
  );
};
